import { Box, Tab, Tabs } from '@mui/material';
import { portalPaths, UrlSegments } from '@provision/portal-routes';
import { Route, Routes } from 'react-router-dom';
import { NamedLayoutBlock } from 'src/components';
import { useNavigateRoute } from 'src/utils/routing';
import { ChannelsEmailView } from './channels-email-view';
import { ChannelsVoiceView } from './channels-voice-view';

const tabs = [
  {
    value: portalPaths.settings.channels(),
    label: 'Email',
  },
  {
    value: portalPaths.settings.channelsVoice(),
    label: 'Voice',
  },
];

export const Channels = () => {
  const { navigate, pathnameWithoutPrefix } = useNavigateRoute();

  return (
    <NamedLayoutBlock
      title="Channels"
      sx={{
        flex: 1,
        display: { sm: 'flex' },
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          marginBottom: '1rem',
        }}
      >
        <Tabs
          aria-label="Tab navigation"
          value={pathnameWithoutPrefix}
          variant="standard"
          TabIndicatorProps={{
            sx: {
              backgroundColor: (theme) => theme.palette.custom.OV.sys.primary,
            },
          }}
        >
          {tabs.map((el) => (
            <Tab
              key={el.label}
              label={el.label}
              value={el.value}
              onClick={() => navigate(el.value)}
              sx={{
                color: (theme) => theme.palette.custom.OV.sys.onSurface,
                '&.Mui-selected': {
                  color: (theme) => theme.palette.custom.OV.sys.primary,
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      <Routes>
        <Route path="/" element={<ChannelsEmailView />} />
        <Route path={UrlSegments.settings.channelsVoice} element={<ChannelsVoiceView />} />
      </Routes>
    </NamedLayoutBlock>
  );
};
